<template>
    <div>
        <span v-if="user" class="ph-no-capture">
            <span
                v-if="!mini"
                class="mr-2 typography1--text text-capitalize text-body-2"
            >
                {{ user.givenName }} {{ user.surname }}
            </span>

            <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="40" v-bind="attrs" v-on="on">
                        <img v-if="userPhoto" :src="userPhoto" />
                        <v-icon v-else>mdi-account-circle</v-icon>
                    </v-avatar>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-avatar size="55">
                            <img v-if="userPhoto" :src="userPhoto" />
                            <v-icon v-else>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ user.displayName }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="d-flex flex-column">
                                <span class="text-caption">{{
                                    user.mail
                                }}</span>
                                <span class="text-caption">{{
                                    user.userId
                                }}</span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-3"></v-divider>
                    <v-list-item-group v-model="selectedItem">
                        <v-list-item>
                            <v-list-item-avatar width="55">
                                <v-icon color="black">mdi-logout</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content> Logout </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-menu>
        </span>

        <v-btn
            v-else
            class="mr-2 typography2--text text-capitalize"
            text
            @click="login"
        >
            Login
        </v-btn>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    data() {
        return {
            selectedItem: null,
        }
    },
    methods: {
        ...mapActions(['logout', 'login']),
    },
    computed: {
        ...mapState(['user', 'userPhoto', 'showProgressLogin']),
        mini() {
            return this.$vuetify.breakpoint.lgAndDown
        },
    },
    async mounted() {
        this.login()
    },
    watch: {
        selectedItem() {
            this.logout()
        },
        showProgressLogin(progress) {
            if (this.$route.name !== 'home') {
                if (!progress && !this.user) {
                    this.$router.push({ path: '/' })
                }
            }
        },
    },
}
</script>

<style></style>
